import React from "react";
import { AbstractDate } from "@linkfluence/models/date";
import { DatavizDoubleTimeChart } from "@radarly/models/dataviz";
import { SearchFragmentDateMetrics } from "@radarly/models/search";
import { useFragmentData } from "../../data";
import Loading from "../../loading";
import Inner from "./inner";

export interface SharedWidgetsMetricsDoubleTimeChartProps {
  project: number;
  fragment: SearchFragmentDateMetrics;
  dataviz: DatavizDoubleTimeChart;
  onClickLegend?: (uid: string | number) => void;
  onClickItem?: (uid: string | number, range: { from: Date; to: Date }) => void;
  className?: string;
  forceReload?: boolean;
  disableAnimation?: boolean;
  nowDate?: AbstractDate;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
}

export default function SharedWidgetsMetricsDoubleTimeChart({
  project,
  fragment,
  forceReload,
  isFullscreen,
  closeFullscreen,
  onClickItem,
  onClickLegend,
  ...props
}: SharedWidgetsMetricsDoubleTimeChartProps) {
  const { loading, data } = useFragmentData(project, fragment);
  const _onClickItem = (
    uid: string | number,
    range: { from: Date; to: Date }
  ) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickItem(uid, range);
  };

  const _onClickLegend = (uid: string | number) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickLegend(uid);
  };

  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Inner
        loading={loading}
        data={data}
        fragment={fragment}
        isFullscreen={isFullscreen}
        onClickItem={_onClickItem}
        onClickLegend={_onClickLegend}
        {...props}
      />
    </Loading>
  );
}
